import React from 'react';
import BreadCrumb from '@/components/shared/BreadCrumb';
import { SEOconfig } from 'next-seo.config';
import { useRouter } from 'next/router';
import { useGetNewsCategoriesBySlugQuery } from '@/generated/graphql';
import { NewsCategoryBottomSection } from './NewsCategoryBottomSection';
import { UrlLink } from '@/configs/urlLink';

function NewsCategoryPage() {
  const router = useRouter();

  const { data: DataDetailCategory } = useGetNewsCategoriesBySlugQuery({
    variables: {
      where: {
        slug: {
          _like: router?.query?.slug?.toString() || '',
        },
      },
    },
  });

  const breadcrumbs = [
    { name: 'Tin Tức', link: UrlLink.news.news },
    {
      name: DataDetailCategory?.news_category?.[0]?.name || '',
      link: `${UrlLink.news.news}/${DataDetailCategory?.news_category?.[0]?.slug}`,
      className: 'text-primary-eastern',
    },
  ];

  return (
    <div className="flex flex-col md:gap-4 lg:gap-8">
      <SEOconfig
        title={`${DataDetailCategory?.news_category?.[0]?.name}  - Tin tức tài chính | Tạp chí Trading`}
        description={
          DataDetailCategory?.news_category?.[0]?.meta_description || ''
        }
        url={router.asPath}
      />
      <div className="flex flex-col md:container md:gap-2">
        <div className="px-4 md:px-0">
          <div className="py-3">
            <BreadCrumb breadcrumbs={breadcrumbs} />
          </div>
          <p className="text-h3 font-header py-2 font-bold">
            {DataDetailCategory?.news_category?.[0]?.name}
          </p>
        </div>
      </div>
      {/* <NewsCategoryTopSection /> */}
      <NewsCategoryBottomSection />
    </div>
  );
}

export default NewsCategoryPage;
